import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    index?: string
    tone?: 'paper' | 'graphite'
    className?: string
}

export const Eyebrow: FC<EyebrowProps> = ({ children, index, tone = 'paper', className }): ReactNode => {
    return (
        <p
            className={cn(
                'flex items-center gap-3 font-mono text-[0.7rem] font-medium uppercase tracking-[0.2em]',
                tone === 'paper' ? 'text-ink/70' : 'text-paper/70',
                className
            )}
        >
            {index && (
                <span className={cn('tabular', tone === 'paper' ? 'text-brand-ink' : 'text-brand')}>
                    {index}
                </span>
            )}

            <span aria-hidden='true' className='h-px w-8 bg-brand' />

            <span>
                {children}
            </span>
        </p>
    )
}
